const NUMERIC_SEGMENT = /^\d+$/;

/**
 * Scrive un valore in un oggetto nested seguendo un path dot-notation.
 * Equivalente alla funzione `set` interna di RHF (index.esm.mjs:79).
 */
export function setByPath(object: any, path: string, value: any) {
  const segments = path.split('.');
  let current = object;
  for (let i = 0; i < segments.length - 1; i++) {
    const key = segments[i];
    if (current[key] == null || typeof current[key] !== 'object') {
      current[key] = NUMERIC_SEGMENT.test(segments[i + 1]) ? [] : {};
    }
    current = current[key];
  }
  current[segments[segments.length - 1]] = value;
}

/**
 * Rimuove un valore da un oggetto nested seguendo un path dot-notation.
 * Dopo il delete, risale e rimuove gli ancestor rimasti vuoti (come la
 * `unset` interna di RHF), così che `Object.keys(obj).length === 0`
 * rifletta correttamente l'assenza di valori.
 */
export function unsetByPath(object: any, path: string) {
  const segments = path.split('.');
  const ancestors: any[] = [object];
  let current = object;
  for (let i = 0; i < segments.length - 1; i++) {
    const key = segments[i];
    if (current[key] == null || typeof current[key] !== 'object') return;
    current = current[key];
    ancestors.push(current);
  }
  delete current[segments[segments.length - 1]];

  // biome-ignore lint/style/useForOf: performance-critical hot path
  for (let i = segments.length - 2; i >= 0; i--) {
    const parent = ancestors[i];
    const key = segments[i];
    const child = parent[key];
    if (Array.isArray(child)) {
      if (child.some(v => v !== undefined)) break;
    } else if (typeof child === 'object' && child !== null) {
      if (Object.keys(child).length > 0) break;
    } else {
      break;
    }
    delete parent[key];
  }
}
